import { render } from "./TemplateTurnoverCard.vue?vue&type=template&id=8f77951c"
import script from "./TemplateTurnoverCard.vue?vue&type=script&lang=js"
export * from "./TemplateTurnoverCard.vue?vue&type=script&lang=js"

import "./TemplateTurnoverCard.vue?vue&type=style&index=0&id=8f77951c&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__